export const formatPercentage = (value: string | number) => {
  const result = typeof value === 'number' ? value.toFixed(2).toString() : value?.trim() || '';

  return result.length === 0 ? '' : `${result}${result.includes('%') ? '' : '%'}`;
}